// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Qz3SR","content":"styles_content__aSj5l","text_content":"styles_text_content__KB24U","link_button":"styles_link_button__-YaXN"};